export const localeMk = {
  systemName:
    "Систем за електронско аплицирање за трајна и времена измена на режим за сообраќај",
  temporaryTrafficChange: "Времена измена на режим",
  permanentTrafficChange: "Трајна измена на режим",
  invalidUsernameOrPassword: "Невалидно корисничко име или лозинка",
  userNotFound: "Корисникот не е пронајден",
  authenticationFailed: "Неуспешна автентикација",
  usernameRequired: "Корисничкото име е задолжително",
  nameRequired: "Име и презиме/Назив на фирма е задолжително",
  surnameRequired: "Презимето е задолжително",
  emailRequired: "Е-поштата е задолжителна",
  enterValidEmail: "Внесете валидна е-пошта",
  phoneNumberRequired: "Телефонскиот број е задолжителен",
  enterValidPhoneNumber: "Внесете валиден телефонски број",
  minOneRoleRequired: "Изберете најмалку една улога",
  rolesRequired: "Улогата е задолжителна",
  "Incorrect keystore password": "Погрешна лозинка",
  "Keystore uploaded successfully": "Датотеката е успешно поставена",
};
